// extracted by mini-css-extract-plugin
export default {"tabContent":"InfoPage_tabContent__EJ0ZY","genericContent":"InfoPage_genericContent__LeNeD"};